export function matchGateway(model, filters) {
  if (model.ports < filters.minimum || (filters.links.length && !filters.links.some(link => model.links.includes(link)))) return undefined;
  return model.variants.find(variant => !filters.serial.length || filters.serial.some(serial => variant.serial.includes(serial)));
}

if (typeof window !== 'undefined' && !customElements.get('yengear-gateway-selector')) {
  customElements.define('yengear-gateway-selector', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('form');
      this.models = [...this.querySelectorAll('[data-gateway]')].map(row => ({ row, links: row.dataset.links.split(','), ports: Number(row.dataset.ports), variants: JSON.parse(row.dataset.variants) }));
      this.page = 0;
      this.form.addEventListener('change', () => { this.page = 0; this.render(); }, options);
      this.form.addEventListener('reset', () => { setTimeout(() => { this.page = 0; this.render(); }, 0); }, options);
      this.querySelector('[data-clear]').addEventListener('click', () => this.form.reset(), options);
      this.querySelector('[data-previous]').addEventListener('click', () => this.changePage(-1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.changePage(1), options);
      this.form.hidden = false;
      this.render();
    }
    disconnectedCallback() { this.controller?.abort(); }
    changePage(delta) { this.page += delta; this.render(); this.querySelector('[data-result-heading]').focus({preventScroll:true}); }
    render() {
      const data = new FormData(this.form);
      const filters = { links: data.getAll('link'), serial: data.getAll('serial'), minimum: Number(data.get('minimum')) };
      const matches = this.models.map(model => ({ model, variant: matchGateway(model, filters) })).filter(item => item.variant);
      const pages = Math.max(1, Math.ceil(matches.length / 4));
      this.page = Math.max(0, Math.min(this.page, pages - 1));
      const visible = matches.slice(this.page * 4, this.page * 4 + 4);
      this.models.forEach(model => { model.row.hidden = !visible.some(item => item.model === model); });
      visible.forEach(({model, variant}) => { model.row.querySelector('[data-product-link]').href = `${model.row.dataset.url}?variant=${variant.id}`; });
      this.querySelector('[data-result-count]').textContent = `${matches.length} matching models`;
      this.querySelector('[data-empty]').hidden = matches.length !== 0;
      this.querySelector('[data-pagination]').hidden = matches.length === 0;
      this.querySelector('[data-page-label]').textContent = `Page ${this.page + 1} of ${pages}`;
      this.querySelector('[data-previous]').disabled = this.page === 0;
      this.querySelector('[data-next]').disabled = this.page === pages - 1;
    }
  });
}
